(function($) {
  $(document).ready(function() {
    /**
     * TOPIC IMAGES.
     * - Temporary fix for embedded images in topic content.
     */
    $('.topic-content img, .js-publication-responsive img').each(function(i, e) {
      var $img = $(e),
          $parent = $img.parent();
      $img.css({ 'max-width': '100%', 'height': 'auto' });

      if ((($img.css('float') == 'left') || ($img.css('float') == 'right')) && $img.css('padding') != '0px') {
        $parent.addClass('thumbnail');
        $img.css({ 'max-height': 'auto', 'max-width': '300px', 'margin-bottom': '20px'});
        if ($img.css('float') == 'left' && $img.css('padding') != '0px') {
          $img.css({ 'margin-right': '20px' });
          $parent.css({ 'margin-right': '0px' });
        } else if ($img.css('float') == 'right' && $img.css('padding') != '0px') {
          $img.css({ 'margin-left': '20px' });
          $parent.css({ 'margin-left': '0px' });
        }
      }
      if (($img.css('float') == 'left') && $img.css('padding') == '0px') {
        $img.css({ 'margin-right': '10px' });
      }
      if (($img.css('float') == 'right') && $img.css('padding') == '0px') {
        $img.css({ 'margin-left': '10px' });
      }
    });

    /**
     * TOPIC TABLES.
     * - Responsive tables in topic content and collapses.
     */
    $('.js-publication-responsive > table, .topic-content > table, #publication-collapses .panel-body > div > table').wrap('<div class="table-responsive"></div>');
  });
})(jQuery);
